const { VUE_APP_URL_TRANSFORM_CONFIG } = process.env;

const config = JSON.parse(VUE_APP_URL_TRANSFORM_CONFIG);

export default config;
